import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { Warehouse, WarehouseService } from '../../services/warehouse.service';

@Component({
  selector: 'app-create-warehouse',
  templateUrl: './create-warehouse.component.html',
  styleUrls: ['./create-warehouse.component.css']
})
export class CreateWarehouseComponent implements OnInit {

  warehouseForm: FormGroup;

  constructor(
    private warehouseService: WarehouseService,
    private fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.createForm();

  }

  createForm() {
    this.warehouseForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      folio: ['', Validators.required]
    });
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    value.products = [];
    this.warehouseService.addWarehouse(value);
  }

}
